export default "/assets/website/images/st7.jpg?28a838636b3322841ab8fc0bafd6c188";